<template lang="pug">

    div
      div( v-if="$apollo.loading" ) Loading, please wait...
      div( v-else-if="networkMany" )
        p( v-if="label" class="mb-1" ) {{ label }}
        p( v-else class="mb-1" ) Select a user to assign:
        select( v-on:input="onInput" v-model="networkName" class="form-control" v-bind:disabled="disabled" )
          option( v-bind:value="null" ) Please select
          option( v-for="network in networkMany" v-bind:value="network.name" ) {{ network.name }}

</template>

<style lang="scss" scoped>
</style>

<script>
import Vue from 'vue'
import gql from 'graphql-tag'
export default Vue.extend({

  props: [ 'label', 'disabled' ],
    
  data() {
    return{
      networkName: '',
    }
  },

  apollo: {
    networkMany: {
      query: gql`
        query responsibleNetworksMany {
          responsibleNetworksMany(limit: 100000) {
            name
            id
          }
        }
      `,
      fetchPolicy: 'no-cache',
    }
  },

  methods: {

    onInput(e) {
      this.$emit('input', e.target.value)
      this.$emit('input-full-object', this.networkMany.find(n => n.name === e.target.value))
    },

  },
    
})
</script>